import { ColumnDef } from '@tanstack/react-table';
import { Workbook } from 'exceljs';

import { WebEDIRowData } from 'components/DataTable/Types';

import { dataTableColumnsToExcelDefinitions } from './adapters/dataTableAdapter';
import { createExcelWorkbook } from './excelGenerator';
import { ExcelWorkbookOptions } from './types';

export const dataTableToExcelWorkbook = (
  columns: Array<ColumnDef<WebEDIRowData, unknown>>,
  options: ExcelWorkbookOptions,
): Workbook => {
  const excelColumns = dataTableColumnsToExcelDefinitions(columns);

  return createExcelWorkbook(excelColumns, options);
};

export type { ExcelWorkbookOptions, ExcelColumnDefinition } from './types';
export { downloadExcel } from './excelDownloader';
